export const NetworkContextName = "Binance test network";
export const ACTIVE_NETWORK = 97;
export const factoryAddress = "0x1B929F68C0Dc7e1Ab1156269A8aF5Ea98b07c8dd";
export const maxApproveAmount =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
export const BUSD = "0x21783c0ce32e1859f6bccc6e575ae6019765e443";
export const USDT = "0x54f6719302106a7462cbea1318b515b2d3ec8456";
export const BNB = "0x0000000000000000000000000000000000000000";
export const RPC_URL_BNB = "https://data-seed-prebsc-1-s3.binance.org:8545/";
